<app-dialog
  [isPrimaryActionDestroying]="isDeleteAction"
  [dialogType]="dialogType"
  customClass="confirm-dialog"
  [trackingObject]="trackingObject"
  [trackingAdditionalProperties]="trackingAdditionalProperties"
  [trackingScreenName]="trackingScreenName"
  [trackingDialogName]="trackingDialogName"
  [primaryActionText]="yesText ? yesText : ('ACTION.OK' | translate)"
  [primaryActionTapped]="primaryActionTapped"
  [primaryActionTrackingAdditionalProperties]="
    primaryActionTrackingAdditionalProperties
  "
  [secondaryActionText]="
    cancelText ? cancelText : ('ACTION.CANCEL' | translate)
  "
  [secondaryActionTrackingAdditionalProperties]="
    secondaryActionTrackingAdditionalProperties
  "
  [secondaryActionTapped]="secondaryActionTapped"
  [dismissActionTapped]="dismissActionTapped"
  (onSecondaryAction)="onSecondaryAction()"
  (onPrimaryAction)="onPrimaryAction()"
  (onCloseAction)="onCancelAction()"
  (onDismissAction)="onCancelAction()"
>
  <div class="confirm-dialog-contents">
    <h4 *ngIf="confirmTitle" class="confirm-title">
      {{ confirmTitle }}
    </h4>

    <p class="confirm-prompt">
      {{ confirmPrompt }}
    </p>

    <ng-content></ng-content>
  </div>
</app-dialog>
